<template>
    <div class="flex flex-col overflow-hidden">
        <div class="flex-none border-b py-1">
            <div class="inline-flex items-center gap-2">
                <span class="text-2xl bold">
                    {{ journey.code }}
                </span>
                <hts-icons
                    v-if="journey.processAlertStatus > 30"
                    svg="warning-sign"
                    class="inline-block"
                    color="red" />
                <hts-icons
                    v-if="journey.totalWaitingTime"
                    svg="hourglass"
                    fill-color="orange"
                    class="inline-block" />
                <hts-icons
                    v-if="hasDriverAlert"
                    svg="driver"
                    color="purple"
                    class="inline-block" />
            </div>
            <div class="right float-right">
                <hts-form-button
                    size="v-mini"
                    color="warning"
                    icon-name="hi-arrows-right-left-icon"
                    @click="openChangeVehicle">
                    Cắt Mooc
                </hts-form-button>
                <hts-form-button
                    size="v-mini"
                    color="warning"
                    icon-name="hi-arrow-path-rounded-square-icon"
                    @click="openChangeVehicleAndMooc">
                    Đổi xe
                </hts-form-button>
                <hts-form-button
                    size="v-mini"
                    color="primary"
                    icon-name="hi-clock-icon"
                    @click="openTiming">
                    Nhập thời gian
                </hts-form-button>
                <hts-form-button
                    size="v-mini"
                    color="info"
                    icon-name="hi-calendar-icon"
                    @click="openPlanning">
                    {{ $t('labels.planningModify') }}
                </hts-form-button>
            </div>
        </div>
        <div class="h-10 py-1">
            <hts-form-toggle
                v-model="expanded"
                size="v-mini"
                color="primary"
                class="inline-block"
                label="Tác vụ: Expand/Collapse" />
        </div>
        <hts-travel-details
            ref="travelRoute"
            :journey-id="journey._id"
            :travel-details="travelDetails"
            :stage-start="journey.stageIndexBegin || journey.stageIndexStart"
            :stage-end="journey.stageIndexEnd"
            :start="journey.travelIndexStart"
            :end="journey.travelIndexEnd"
            direction="horizontal"
            class="flex-1 overflow-auto"
            @clickStep="clickStep" />
    </div>
</template>

<script setup lang="ts">
import routeMap from '@/pages/trucker-[id]/route/ignore/route-map'

const { setMarkers, setRoutes, setRoutingPositions } = routeMap()

const emits = defineEmits(['modify', 'update-route', 'open-timing', 'open-planning', 'open-change-vehicle', 'open-change-vehicle-and-mooc'])
const localTravelDetails = ref<{ [key: string]: any }[]>([])
const localPositionsAndWaitingTasks = ref<{ [key: string]: any }[]>([])
const travelRoute = ref<any>(null)
const props = defineProps({
  journey: {
    type: Object,
    required: true
  }
})

const { journey } = toRefs(props)
const travelDetails = computed(() => journey.value?.travelDetails)
const positionsAndWaitingTasks = computed(() => journey.value?.positionsAndWaitingTasks)
const expanded = ref(false)
const showJourney = ref(false)

const hasDriverAlert = computed(() => {
  return Array.isArray(journey.value?.alerts) && journey.value?.driverAlerts?.filter((a: any) => !a.skipped).length
})

onMounted(() => {
  localTravelDetails.value = travelDetails?.value || []
  localPositionsAndWaitingTasks.value = positionsAndWaitingTasks?.value || []

  if (journey?.value?.routingPositions) {
    setRoutingPositions(journey.value.routingPositions)
    setMarkers(journey.value.stages)
    setRoutes(journey.value.stages)
  }
})

const show = (journey: any) => {
  localTravelDetails.value = journey.travelDetails
  localPositionsAndWaitingTasks.value = journey.positionsAndWaitingTasks

  if (journey.routingPositions) {
    setRoutingPositions(journey.routingPositions)
    setMarkers(journey.stages)
    setRoutes(journey.stages)
  }
}

const close = () => {
  localTravelDetails.value = []
  localPositionsAndWaitingTasks.value = []
}

const nodeShowTasks = ref([] as string[])

const clickStep = (value: any) => {
  if (!value?._id) {
    return
  }

  if (nodeShowTasks.value.includes(value._id)) {
    nodeShowTasks.value = nodeShowTasks.value.filter((id) => id !== value._id)
    return
  }
  nodeShowTasks.value.push(value._id)
}
watch(
  () => expanded.value,
  () => {
    toggleExpandCollapse()
  }
)
const toggleExpandCollapse = $lodash.debounce(() => {
  if (!travelRoute.value) {
    return
  }
  travelRoute.value.toggleExpandCollapse()
}, 300)

const openPlanning = (e: any) => {
  emits('open-planning', e)
}
const openTiming = (e: any) => {
  emits('open-timing', e)
}
const openChangeVehicle = (e: any) => {
  emits('open-change-vehicle', e)
}
const openChangeVehicleAndMooc = (e: any) => {
  emits('open-change-vehicle-and-mooc', e)
}

defineExpose({
  show,
  close
})
</script>
